
  import Vue from 'vue';
  export default {
    scrollToTop: true,
    head() {
      return {
        title: this.title ,
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title
          },
          {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Sukh Karta Dukh Harta" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Sukh Karta Dukh Harta" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Ganpati Aarti, Sukh Karta Dukh Harta, Sukh Karta Dukh Harta Marathi Aarti, Sukh Karta Dukh Harta English Aarti, सुखकर्ता दुखहर्ता आरती, sukh karta dukh harta lyrics in english, sukh karta dukh harta aarti lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Ganpati Aarti, Sukh Karta Dukh Harta, Sukh Karta Dukh Harta Marathi Aarti, Sukh Karta Dukh Harta English Aarti, Ganesh Chaturthi, Ganpati Puja, Devotional aarti, Ganpati Lyrics, सुखकर्ता दुखहर्ता आरती, sukh karta dukh harta lyrics in english, sukh karta dukh harta aarti lyrics, sukh karta dukh harta lyrics in english,'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/ganesh.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/ganesh.webp'
          },
        ],
      }
    },
    components: {
    },
    data() {
      return {
        title: 'Sukh Karta Dukh Harta | Ganpati Aarti - सुखकर्ता दुःखहर्ता (गणपती आरती)',
        langauageMarathi: true
      }
    },
    layout: 'detailsPage-withoutFooter',

    jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/ganesh"
        },
        "headline": "Sukh Karta Dukh Harta -  सुखकर्ता दुःखहर्ता (गणपती आरती)",
        "name" : "Sukh Karta Dukh Harta - Ganpati Aarti",
        "description":"Explore the full lyrics of Aarti 'Sukh Karta Dukh Harta' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/ganesh.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },

    computed: {

    },
    methods:{
      changeLanguage:function () {
        this.langauageMarathi = !this.langauageMarathi
      }
    }

  }
